import React, { useState, useEffect } from "react";
import { getData } from "app/data";
import PageHeader from "components/PageHeader/TitleSubtitlePageHeader/MerchantService";
import CommonUseCases from "components/CommonUseCases"
import WaitingFor from "components/Banner/WaitingFor";
import ProductCard from "../../ProductCard";

export default function Index() {
    const data = getData("selectYourIndustry50To100KData");
    const [activeBtn, setActiveBtn] = useState("merchant-service");
    useEffect(() => {
        let urlArr = window.location.pathname.split("/");
        setActiveBtn(urlArr[1])
    }, []);
    return (
        <div className="merchant-service-page">
            <PageHeader
                title="merchant_service"
                subtitle="browse_pos_devices"
                subtitle2="browse_by_use_cases"
                subtitle3="service_rate"
                subtitleColorGreen={true}
                activeBtn={activeBtn}
                // modified code
                introduction="merchant_service_introduction"
            />
            <hr />
            <div className="industry-list">
                <div className="container div-wrapper">
                    <div className="row">
                        {data.map((item) => (
                            <ProductCard
                                key={item.title}
                                link={item.link}
                                title={item.title}
                                subtitle={item.text}
                                showImage={false}
                                showHover={false}
                                hashTag={item.hash}
                            />
                        ))}
                    </div>
                </div>
            </div>

            <CommonUseCases data="posDevicesData" />
            <WaitingFor />
        </div>
    );
}
